export default __webpack_public_path__ + "static/media/section2a-clientsdecor.c0601f0c.svg";